import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Loading, Space, Tag } from 'tdesign-react';
import { fetchClusterInfo } from '@/slices/resourceSlice';
import Panel from '@/components/Panel';
import Descriptions from '@/components/Descriptions';
import yesPng from '../../images/check-circle.png';
import noPng from '../../images/x-circle.png';
import Summary from './Summary';

const subTitleStyle = { fontSize: 12, fontWeight: 400, marginTop: -10 };

function ClusterDetail({ fetchClusterInfo, info, infoFetching }) {
  const { id } = useParams();

  useEffect(() => {
    fetchClusterInfo(id);
  }, [id, fetchClusterInfo]);

  return (
    <Loading loading={infoFetching}>
      <Root>
        <Summary overview={info} />
        <Panel style={{ marginTop: 18 }}>
          <Descriptions.Panel title='环境信息' bordered>
            <Descriptions title='基础信息' titleStyle={subTitleStyle}>
              <Descriptions.Item label='集群名称' value={info.name} />
              <Descriptions.Item label='所属环境' value={info.envName} />
            </Descriptions>
            <Descriptions title='代理信息' titleStyle={subTitleStyle}>
              <Descriptions.Item label='代理名称' value={info.opsProxyInfoVO?.proxyName} />
              <Descriptions.Item
                label='代理地址'
                span={2}
                value={info.opsProxyInfoVO?.urlObj?.map((item, index) => (
                  <Space key={index}>{`http://${item.host}:${item.port}${
                    info.opsProxyInfoVO?.proxyPath || ''
                  }`}</Space>
                ))}
              />
            </Descriptions>
            <Descriptions title='制品信息' titleStyle={subTitleStyle}>
              <Descriptions.Item label='制品名称' value={info.productLibName} />
              <Descriptions.Item label='制品类型' value={info.productLibType} />
            </Descriptions>
          </Descriptions.Panel>
          <Descriptions.Panel title='服务信息' style={{ marginTop: 12 }} bordered>
            <Descriptions column={2} titleStyle={subTitleStyle}>
              <Descriptions.Item label='bookieAdmin地址' value={info.bookieAdminUrl} />
              <Descriptions.Item
                label='booker地址'
                value={
                  <Space breakLine size={[10, 0]}>
                    <span>{info.brokerServiceUrl}</span>
                    <span>{info.brokerAdminUrl}</span>
                  </Space>
                }
              />
              <Descriptions.Item label='function服务地址' value={info.functionServiceUrl} />
              <Descriptions.Item label='granfana服务地址' value={info.granfanaServiceUrl} />
              <Descriptions.Item label='kop服务地址' value={info.kopServiceUrl} />
              <Descriptions.Item label='metrics服务地址' value={info.metricsServiceUrl} />
              <Descriptions.Item label='prometheus服务地址' value={info.prometheusServiceUrl} />
            </Descriptions>
            <Descriptions
              style={{ padding: '10px 24px', marginTop: 6, borderRadius: 6, background: '#F7F8FA' }}
              titleStyle={subTitleStyle}
            >
              <Descriptions.Item label='开启Kop' value={<Icon yes={info.serviceKop} />} />
              <Descriptions.Item
                label='开启Grafana'
                value={<Icon yes={info.isOpenGrafanaService} />}
              />
              <Descriptions.Item
                label='开启Function'
                value={<Icon yes={info.openFunctionService} />}
              />
            </Descriptions>
          </Descriptions.Panel>
          <Descriptions.Panel title='组件信息' style={{ marginTop: 12 }} bordered>
            <Space breakLine style={{ marginTop: 5 }}>
              {info.componentList?.map((item, index) => (
                <Tag key={index}>{item}</Tag>
              ))}
            </Space>
          </Descriptions.Panel>
        </Panel>
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    info: state.resource.info,
    infoFetching: state.resource.infoFetching,
  }),
  {
    fetchClusterInfo,
  },
)(ClusterDetail);

const Root = styled.div`
  padding-right: 20px;
`;

const Icon = styled.div`
  width: 20px;
  height: 22px;
  background-image: url(${(props) => (props.yes ? yesPng : noPng)});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;
